import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import MainTvResetParentalCode from './MainTvResetParentalCode';
import TvResetParentalCodeBlockData from '../../../Models/Content/TvResetParentalCodeBlockData';

export default class TvResetParentalCodeBlock extends EpiComponent<TvResetParentalCodeBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainTvResetParentalCode context={this.getContext()} contentData={this.props.data} />;
  }
}
 